import React from 'react'

import FieldLabel from '@react/react-spectrum/FieldLabel'
import Textfield from '@react/react-spectrum/Textfield'
import Select from '@react/react-spectrum/Select'
import Switch from '@react/react-spectrum/Switch'

import MediaUpload from 'components/MediaUpload'
import { RichTextFormField } from 'components/RichTextEditor'
import { ScreenPicker } from '../../ScreenPicker'

const HeroBanner = ({ screen, project, projectConfig, disabled, onChange }) => {
  const content = screen?.content
  return (
    <>
      <FieldLabel label='Summary'>
        <RichTextFormField
          label='Page Summary'
          value={content.subtitle || ''}
          onChange={onChange('subtitle')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Heading'>
        <Textfield
          placeholder='Heading'
          name='heading'
          value={content.heading || ''}
          onChange={onChange('heading')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Hero Description'>
        <Textfield
          placeholder='Description'
          name='heroDescription'
          value={content.heroDescription || ''}
          onChange={onChange('heroDescription')}
          disabled={disabled}
          multiLine
        />
      </FieldLabel>

      <FieldLabel label='Banner Text Position'>
        <Select
          aria-label='Banner Text Position'
          options={projectConfig.bannerPositionOptions}
          placeholder={'Select an option'}
          name='bannerTextPosition'
          value={content.bannerTextPosition || ''}
          onChange={onChange('bannerTextPosition')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Hero Image' labelFor='heroImage'>
        <Switch
          label='Full width'
          checked={!!content.isFullWidthBanner}
          onChange={(v) => !disabled && onChange('isFullWidthBanner')(v)}
        />
        <MediaUpload
          type='image'
          value={content.heroImage || ''}
          maxHeight='100px'
          onUpload={onChange('heroImage')}
          projectId={project?.meta?.id}
          path={`dashboard-${screen?.meta?.name}-heroImage`}
          withTextfield={true}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Button Label'>
        <Textfield
          placeholder='Button Label'
          name='buttonLabel'
          value={content.buttonLabel || ''}
          onChange={onChange('buttonLabel')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Button Link'>
        <ScreenPicker
          screenName={screen?.meta?.name}
          value={content.buttonLink}
          onChange={onChange('buttonLink')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Login Form Title'>
        <Textfield
          placeholder='Login Title'
          name='loginFormTitle'
          value={content.loginFormTitle || ''}
          onChange={onChange('loginFormTitle')}
          disabled={disabled}
        />
      </FieldLabel>
    </>
  )
}

const ChildScreens = ({ screen, disabled, onChange }) => {
  const content = screen?.content
  return (
    <>
      <FieldLabel label='List Headline' labelFor='listHeadline'>
        <Textfield
          placeholder='List Headline'
          name='listHeadline'
          value={content.listHeadline || ''}
          onChange={onChange('listHeadline')}
          disabled={disabled}
        />
      </FieldLabel>

      <ScreenPicker
        screenName={screen?.meta?.name}
        screens={content.primaryList}
        onChange={onChange('primaryList')}
        disabled={disabled}
        multiple
      />
      <FieldLabel label='Second List Renderer'>
        <Textfield
          placeholder=''
          name='secondaryListRenderer'
          value={content.secondaryListRenderer || ''}
          onChange={onChange('secondaryListRenderer')}
          disabled={disabled}
        />
      </FieldLabel>
      <FieldLabel label='Second List Headline'>
        <Textfield
          placeholder=''
          name='secondaryListHeadline'
          value={content.secondaryListHeadline || ''}
          onChange={onChange('secondaryListHeadline')}
        />
      </FieldLabel>

      <ScreenPicker
        screenName={screen?.meta?.name}
        screens={content.secondaryList}
        onChange={onChange('secondaryList')}
        disabled={disabled}
        multiple
      />
    </>
  )
}
const AuthorizedVariant = ({ screen, disabled, onChange }) => {
  const content = screen?.content
  return (
    <>
      <Switch
        label='Show Login Form'
        checked={!!content.showLoginForm}
        onChange={(v) => !disabled && onChange('showLoginForm')(v)}
      />
      <FieldLabel label='Redirect to'>
        <ScreenPicker
          screenName={screen?.meta?.name}
          screens={content.authorizedVariant}
          value={content.authorizedVariant}
          onChange={onChange('authorizedVariant')}
          disabled={disabled}
        />
      </FieldLabel>
      <br />
      <br />
      <br />
      <br />
      <br />
    </>
  )
}

export default [
  { label: 'Hero Banner', content: HeroBanner },
  { label: 'Child Screens', content: ChildScreens },
  { label: 'Authorized Variant', content: AuthorizedVariant },
]
